import { AlertTriangle, AlertOctagon, Info, ExternalLink } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const SEV = {
  critical: { Icon: AlertOctagon, bg: "bg-rose-50",    border: "border-rose-200",   text: "text-rose-700",   dot: "bg-rose-500" },
  warning:  { Icon: AlertTriangle, bg: "bg-amber-50",  border: "border-amber-200",  text: "text-amber-700",  dot: "bg-amber-500" },
  info:     { Icon: Info,         bg: "bg-sky-50",    border: "border-sky-200",    text: "text-sky-700",    dot: "bg-sky-500" },
};

export default function AlertsPanel({ alerts = [], loading }) {
  return (
    <div className="rounded-xl border border-border bg-white" data-testid="alerts-panel">
      <div className="flex items-center justify-between px-4 h-12 border-b border-border">
        <div className="flex items-center gap-2">
          <span className="relative inline-flex h-2 w-2">
            <span className="absolute inset-0 inline-flex h-full w-full rounded-full bg-rose-500/40 animate-ping" />
            <span className="relative inline-flex h-2 w-2 rounded-full bg-rose-500" />
          </span>
          <h3 className="font-display font-semibold text-sm">Alerte operaționale</h3>
        </div>
        <span className="text-[11px] text-muted-foreground tabular-nums">{alerts.length} active</span>
      </div>
      <div className="divide-y divide-border max-h-[420px] overflow-y-auto">
        {loading && Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="px-4 py-3 animate-pulse">
            <div className="h-3 w-1/2 bg-zinc-200 rounded" />
            <div className="h-2 w-3/4 bg-zinc-100 rounded mt-2" />
          </div>
        ))}
        {!loading && alerts.length === 0 && (
          <div className="px-4 py-12 text-center text-sm text-muted-foreground">
            Toate operațiunile par stabile. Niciun semnal critic.
          </div>
        )}
        {!loading && alerts.map((a) => {
          const v = SEV[a.severity] || SEV.info;
          const Body = (
            <div className={cn("px-4 py-3 flex items-start gap-3 group hover:bg-zinc-50 transition")}>
              <div className={cn("h-8 w-8 rounded-md flex items-center justify-center shrink-0", v.bg, v.border, "border")}>
                <v.Icon className={cn("h-4 w-4", v.text)} />
              </div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <span className={cn("text-[9px] font-semibold uppercase tracking-widest", v.text)}>
                    {a.severity}
                  </span>
                  <span className="text-[10px] text-muted-foreground">{a.category}</span>
                </div>
                <div className="text-sm font-medium leading-snug mt-0.5">{a.title}</div>
                {a.detail && <div className="text-xs text-muted-foreground mt-0.5 leading-snug">{a.detail}</div>}
              </div>
              {a.link && <ExternalLink className="h-3.5 w-3.5 text-muted-foreground opacity-0 group-hover:opacity-100 transition shrink-0 mt-1" />}
            </div>
          );
          return a.link ? (
            <Link to={a.link} key={a.id} data-testid={`alert-${a.id}`}>{Body}</Link>
          ) : (
            <div key={a.id} data-testid={`alert-${a.id}`}>{Body}</div>
          );
        })}
      </div>
    </div>
  );
}
